export default {"src":"/_next/static/media/aboutUs.34edf7d3.svg","height":42,"width":42};